<script>
  import ScanPopup from "./scanPopup.svelte";
  import {
    mobileCheck,
    getMobileOperatingSystem,
  } from "../utils/platformUtils.js";
  import productsData from "../../public/data/productsData";

  export let coregvId;
  let scanPopup;
  let arBtn;
  let arHref;
  let product = filterByKey(productsData, "coregvId", coregvId);

  function handleClick() {
    const isMobile = mobileCheck();
    const mobileOS = getMobileOperatingSystem();

    if (isMobile && mobileOS == "Android") {
      console.log("android");
      // Using Scene Viewer to display interactive 3D models in AR from an Android app or browser
      // see: https://developers.google.com/ar/develop/scene-viewer#html
      window.location = `intent://arvr.google.com/scene-viewer/1.0?file=${product["androidModelLink"]}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`;
    } else if (isMobile && mobileOS == "iOS") {
      console.log("iOS");
      // window.location = product["IOSModelLink"];
      arHref = product["IOSModelLink"];
      arBtn.click();
    } else if (
      /Macintosh/.test(navigator.userAgent) &&
      "ontouchend" in document
    ) {
      console.log("iOS");
      // window.location = product["IOSModelLink"];
      arHref = product["IOSModelLink"];
      arBtn.click();
    } else {
      console.log("desktop");
      scanPopup.show();
    }
  }

  function filterByKey(jsonObject, key, value) {
    return jsonObject.filter((obj) => obj[key] == value)[0];
  }
</script>

<div class="scanContainer">
  <button class="scanBtn btn-3" on:click={handleClick}>
    <a href={arHref} bind:this={arBtn} style="display: none;" rel="ar">
      <img src="data:," width="0" height="0" alt="" />
    </a>
    <div class="btnContainer">
      <span href="#" class="scanBtnIcon" />
      <link rel="preload" as="image" href="../img/btn/scan_btn_blue.svg" />
      <p>Im Raum</p>
      <p>platzieren</p>
    </div>
  </button>
  <ScanPopup bind:this={scanPopup} {product} />
</div>

<style>
  .scanContainer {
    position: fixed;
    top: 30%;
    right: 2rem;
    /* z-index must be greater than info points popup components, which is 999 */
    z-index: 1000;
  }
  .scanBtn {
    margin: 0;
    padding: 0;
    color: #fff;
    border-radius: 13px;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    outline: none;
  }
  .btnContainer {
    outline: none;
    border: 0;
    padding: 0.9em 1.1em 0.6em;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .btnContainer p {
    margin-bottom: 0;
  }
  .scanBtnIcon {
    background: url(../img/btn/scan_btn_white.svg) no-repeat center;
    display: block;
    height: 60px;
    margin-bottom: 10px;
    transition: background-image 0.3s ease-in-out;
  }

  .scanBtn p {
    font-size: 14px;
    text-align: center;
    line-height: 1rem;
    transition: color 0.3s ease-in-out;
  }
  .btn-3 {
    background: rgb(21, 140, 201);
    border: solid 1px rgb(168, 190, 201);
  }

  @media only screen and (max-width: 540px) {
    .scanContainer {
      right: -1px;
    }
    .scanBtn {
      transform: scale(0.7);
    }
  }
</style>
